import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'app-theme-provider-sme-light',
  standalone: true,
  styleUrl: './theme-provider-sme-light.component.scss',
  template: '<ng-content />',
})
export class ThemeProviderSmeLightComponent {}
